import OverflowTooltip from "components/elements/Tooltips/OverflowTooltip";
import { getFileExtension } from "lib/actions/files";
import { classes } from "lib/actions/util/classes";
import FileTypeIcon from "components/icons/FileTypeIcon";
import TickCircle from "components/icons/24/notifications/tick-circle.svg";
import CircleOutline from "components/icons/24/other/circle.svg";

type RequiredFileCardProps = {
  fileName: string;
  fileExtension?: string | null;
  missing?: boolean | null;
};

const RequiredFileCard = ({
  fileName,
  fileExtension = null,
  missing = false,
}: RequiredFileCardProps): React.JSX.Element => {
  fileExtension ??= getFileExtension(fileName);

  return (
    <div
      key={fileName}
      className={classes(
        "flex items-center space-x-2 rounded-md border p-2 shadow-sm",
        missing && "bg-amber-100",
      )}
    >
      <div className="w-11 rounded-full border border-gray-300 p-2">
        <FileTypeIcon fileExtension={fileExtension} />
      </div>

      <OverflowTooltip>
        {missing ? `${fileExtension?.toUpperCase()} file is missing` : fileName}
      </OverflowTooltip>

      {missing && <CircleOutline className="w-5" />}
      {!missing && <TickCircle className="w-5 text-green-500" />}
    </div>
  );
};

export default RequiredFileCard;
